

















































































import Vue, { PropType } from 'vue';
// import { BoothData } from '@/modules/exhibitor/booth';
// import { Brand } from '@/modules/exhibitor/brand';

import {
  BoothData,
  Brand,
} from 'mostra';

interface BrandOption {
  value: string | null;
  text: string;
}
interface DataType {
  brandOption: BrandOption[];
  descriptionTexts: object;
}
// type DescriptionKind = 'name' | 'booth' | 'site' | 'order';

interface DescriptionTexts {
  name: string[],
  booth: string[],
  site: string[],
  order: string[],
}

const descriptionTexts: DescriptionTexts = {
  name: ['ブランド名やシーズンなど展示会で表示したいブースの名前を記載してください'],
  booth: ['実際(オフライン)の展示会の開催期間を記入してください'],
  site: ['Granstra上でのサイト公開期間になります。公開した後も変更は可能です'],
  order: ['受注期間は公開後も変更は可能になります'],
};

export default Vue.extend({
  name: 'GBoothSettingForm',
  props: {
    booth: {
      type: Object as PropType<BoothData>,
      required: true,
    },
    brands: {
      type: Array as PropType<Brand[]>,
      required: true,
    },
    isEdit: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data(): DataType {
    return {
      brandOption: [],
      descriptionTexts: descriptionTexts,
    };
  },
  methods: {
    setBrandOption() {
      this.brandOption = this.brands.map(({ data, id }) => ({ value: id, text: data.base.name }));
    },
  },
  mounted() {
    this.setBrandOption();
  },
});
